export default {
    Get: {
        LIST_ENVIRONMENT_PICTURE_TYPE: 'getListEnvironmentPictureType',
        LIST_PROPERTY_ENVIRONMENT: 'getSelectPropertyEnvironment',
        LIST_PROPERTY_ENVIRONMENT_POINT: 'getListOfPropertyEnvironmentPoint',
        LIST_PROPERTY_ENVIRONMENT_POINT_GROUP: 'getListOfPropertyEnvironmentPointGroups',
        LIST_PICTURE_PROPERTY_ENVIRONMENT: 'getPictureOfPropertyEnvironment',
        LIST_PROPERTY_ENVIRONMENT_MAP_VIEW: 'getListOfPropertyEnvironmentMapView',
        URL_PICTURE_FROM_STORAGE:'getFullUrlFromStorage',
        LIST_PROPERTY_ENVIRONMENT_OPTION_POI: 'getListOfPropertyEnvironmentOptionPoi',
        ENVIRONMENT_ADDRESS: 'getEnvironmentAddress',
    },
    Set: {
        LIST_PROPERTY_ENVIRONMENT: 'setSelectPropertyEnvironment',
        SET_PROPERTY_ENVIRONMENT: 'setPropertyEnvironment',
        LIST_PROPERTY_ENVIRONMENT_POINT: 'setListOfPropertyEnvironmentPoint',
        LIST_PICTURE_PROPERTY_ENVIRONMENT: 'setPictureOfPropertyEnvironment',
        UPDATE_PICTURE_PROPERTY_ENVIRONMENT: 'updateOrInsertPictureOfPropertyEnvironment',
        URL_PICTURE_FROM_STORAGE:'setFullUrlFromStorage',
        ASSIGVALUE_TO_OPTION_VIEW: 'setAssignValueToOptionView',
        ASSIGVALUE_TO_TYPE_POINT: 'setAssignValueToTypePoint',
        ENVIRONMENT_ADDRESS: 'setEnvironmentAddress',
        ENVIRONMENT_ADDRESS_VALUE: 'setEnvironmentAddressValue',
    }
};